import '../../Scss/layout.scss'
import Ticker from './styles/Ticker'
import Background from './styles/Background'
import CookieConsent from './styles/CookieConsent'
import FAQ from './pages/FAQ'
import Order from './pages/Order'
import Directmarketing from './pages/Directmarketing'
import JobVacancies from './pages/JobVacancies'
import StartPage from './pages/StartPage'
import TickerData from './components/TickerData'
import { chart } from './components/chart'
import { averageChart } from './components/average_chart'
import PageContentOpacity from './components/PageContentOpacity'
import NavigationWrap from './components/NavigationWrap'
import NavigationFixed from './components/NavigationFixed'
import LanguageDropdown from './components/LanguageDropdown'
import TextSlider from './components/TextSlider'
import FinishDialog from './components/FinishDialog'
import RequestDialog from './components/RequestDialog'
import Datepicker from './components/Datepicker'
import Tabs from './components/Tabs'
import Table from './components/Table'
import Share from './components/Share'
import DownloadLink from './components/DownloadLink'
import SeparatorLine from './components/SeparatorLine'
import Dropdown from './components/Dropdown'
import Input from './components/Input'
import Contract from './components/Contract'
import SubscribeNewsLetter from './components/Newsletter'
import { LogoSlider } from './components/LogoSlider'
import { VideoPlayer } from './components/VideoPlayer'
import { FlipOut } from './components/FlipOut'

document.addEventListener('DOMContentLoaded', () => {
TickerData.init()
CookieConsent.init()
Ticker.init()
Background.init()
FAQ.init()
chart()
averageChart()
TextSlider.init()
PageContentOpacity.init()
NavigationWrap.init()
NavigationFixed.init()
LanguageDropdown.init()
Order.init()
Directmarketing.init()
FinishDialog.init()
RequestDialog.init()
Datepicker.init()
Tabs.init()
Table.init()
Share.init()
DownloadLink.init()
SeparatorLine.init()
Dropdown.init()
Input.init()
StartPage.init()
Contract.init()
JobVacancies.init()
SubscribeNewsLetter()
LogoSlider()
VideoPlayer()
FlipOut()
})
